var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "almost-empty" }, [
      _c("p", { staticClass: "alert" }, [
        _vm._v("\n    Consegui encontrar apenas esses profissionais.\n  ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [
        _vm._v(
          "\n    Você pode remover algum filtro da pesquisa que você considere maleável para ampliar a quantidade de profissionais retornado. Filtros como a hora inicial e dia podem restringir muito a pesquisa.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "tip" }, [
        _c("b", [_vm._v("Dica")]),
        _vm._v(
          ": Para mostrar os profissionais disponíveis perto de você basta selecionar o endereço e pesquisar.\n  "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-771bc58c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-771bc58c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/AlmostEmpty.vue
// module id = null
// module chunks = 